import { TdsBreadcrumb, TdsBreadcrumbs } from '@scania/tegel-react'
import { Link } from 'react-router-dom'

export type Breadcrumb = {
  text: string
  to: string
}
export interface BreadcrumbsProps {
  links: Breadcrumb[]
}

export function Breadcrumbs({ links }: BreadcrumbsProps): JSX.Element {
  return (
    <TdsBreadcrumbs>
      {links.map(link => (
        <TdsBreadcrumb key={Math.random()}>
          <Link to={link.to}>{link.text}</Link>
        </TdsBreadcrumb>
      ))}
    </TdsBreadcrumbs>
  )
}
